/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import React from "react";
import {
  ErrorStateComponent,
  ErrorStateIconType,
  IErrorStateComponentProps,
} from "@cseo/controls";

const payload: IErrorStateComponentProps = {
  headingText: "We’ll be back soon!",
  descriptionText:
    "Sorry, the References Portal is currently unavailable. Please try reloading the page or check back later. We apologize for the inconvenience.",
  iconType: ErrorStateIconType.DataIssue,
  callToActionButton: {
    ctaText: "Reload page",
    ctaAriaLabel: "Click here to reload the page",
    ctaHandler: () => history.go(0),
  },
  styles: {
    root: {
      paddingTop: 10,
      paddingBottom: 10,
    },
  },
};

export const ServiceErrorBody: React.FC = () => {
  return <ErrorStateComponent {...payload} />;
};
